import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';
/**
 * Canvas fixo do card de divulgação e posição fixa da moldura de rosto dentro dele.
 * Usado tanto pelo editor de encaixe (apps/web) quanto por uma futura etapa de
 * geração de card — não muda por DJ, é a mesma referência sempre.
 */
export const CARD_CANVAS_W = 1080;
export const CARD_CANVAS_H = 1920;
export const CARD_FRAME_CENTER_X = 540;
export const CARD_FRAME_CENTER_Y = 518.58;
export const CARD_FRAME_W = 255;
export const CARD_FRAME_H = 354;
/**
 * Transform (translate/rotate/scale) aplicado ao retrato do DJ pra encaixar o
 * rosto na moldura fixa do card (ver constantes CARD_* acima). x/y são offsets
 * em px do canvas 1080x1920 (0,0 = imagem centralizada no canvas). scale é
 * multiplicador aplicado ao tamanho natural (img_w x img_h) da imagem.
 */
export const faceFitSchema = z.object({
    img_w: idSchema,
    img_h: idSchema,
    scale: z.number().positive().max(10),
    rotate: z.number().min(-180).max(180),
    x: z.number(),
    y: z.number(),
});
export const attractionSchema = z.object({
    id: idSchema,
    brand_id: idSchema,
    name: z.string().min(1).max(120),
    instagram: z.string().max(120).nullable(),
    photo_url: z.string().max(500).nullable(),
    portrait_url: z.string().max(500).nullable(),
    face_fit: faceFitSchema.nullable(),
    created_by: idSchema,
    created_at: isoDateTimeSchema,
    updated_at: isoDateTimeSchema,
});
export const attractionCreateInputSchema = z.object({
    brand_id: idSchema.default(1),
    name: z.string().min(1).max(120),
    instagram: z.string().max(120).nullable().optional(),
});
export const attractionUpdateInputSchema = z.object({
    name: z.string().min(1).max(120).optional(),
    instagram: z.string().max(120).nullable().optional(),
});
//# sourceMappingURL=attraction.js.map